module.exports = __webpack_public_path__ + "static/img/xi_2.d6dfb27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_2.jpg
// module id = R5SV
// module chunks = 1